import { useAddSubGoal } from 'features/goals';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Plus } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import { MoveGoalMenuItem } from 'shared/components/ui/move-goal-menu-item';
import {
  PopupMenuButton,
  PopupMenuList,
  PopupMenuListItem,
} from 'shared/components/ui/popup-menu';
import { Goal } from 'shared/types/goal';

export type MoveGoalListProps = {
  goal: Goal;
  onClose: () => void;
  openGoalSelect: () => void;
};

export const MoveGoalList: React.FC<MoveGoalListProps> = ({
  goal,
  onClose,
  openGoalSelect,
}) => {
  const { t } = useTranslation();
  const { onAddSubGoal } = useAddSubGoal(goal);

  const onCreateSubGoal = (e: React.MouseEvent) => {
    e.preventDefault();
    onAddSubGoal();

    onClose();
  };

  return (
    <PopupMenuList hasBottomBorder>
      <MoveGoalMenuItem onSelect={openGoalSelect} />
      <PopupMenuListItem>
        <PopupMenuButton onClick={onCreateSubGoal} start={<Icon icon={Plus} />}>
          {t('context-menus.goal.labels.add-sub-goal')}
        </PopupMenuButton>
      </PopupMenuListItem>
    </PopupMenuList>
  );
};
